import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Loader2, ArrowLeft, Mail, CheckCircle } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axios.post(`${API}/auth/reset-password`, { email });
      setSubmitted(true);
      toast.success('Se l\'email esiste, riceverai le istruzioni per il reset');
    } catch (error) {
      console.error('Reset password error:', error);
      toast.error('Errore durante la richiesta. Riprova più tardi.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F5FBF9] to-[#E8F5F2] p-4">
        <div className="w-full max-w-md">
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-100 text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-8 h-8 text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Email Inviata!</h2>
            <p className="text-slate-600 mb-6">
              Se l'indirizzo <strong>{email}</strong> è registrato nel sistema, 
              riceverai un'email con le istruzioni per reimpostare la password.
            </p>
            <p className="text-sm text-slate-500 mb-6">
              Controlla anche la cartella spam se non trovi l'email.
            </p>
            <button
              onClick={() => navigate('/login')}
              className="w-full bg-[#3BA99C] hover:bg-[#2D8A7F] text-white font-semibold py-3 rounded-lg transition-all"
              data-testid="back-to-login-btn"
            >
              Torna al Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F5FBF9] to-[#E8F5F2] p-4">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-slate-100">
          {/* Header */}
          <button
            onClick={() => navigate('/login')}
            className="flex items-center gap-2 text-slate-600 hover:text-[#3BA99C] mb-6 transition-colors"
            data-testid="back-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            Torna al login
          </button>

          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-[#3BA99C]/10 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="w-8 h-8 text-[#3BA99C]" />
            </div>
            <h1 className="text-2xl font-bold text-slate-900 mb-2">Password Dimenticata?</h1>
            <p className="text-slate-500">
              Inserisci la tua email e ti invieremo le istruzioni per reimpostare la password.
            </p>
          </div>

          {/* Form */}
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="reset-password-form">
            <div>
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="w-full px-4 py-3 rounded-lg border border-slate-200 focus:outline-none focus:ring-2 focus:ring-[#3BA99C] focus:border-transparent transition-all"
                placeholder="email@esempio.it"
                data-testid="email-input"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#3BA99C] hover:bg-[#2D8A7F] text-white font-semibold py-3 rounded-lg transition-all duration-200 shadow-sm hover:shadow-md disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
              data-testid="submit-btn"
            >
              {loading ? (
                <>
                  <Loader2 className="w-5 h-5 animate-spin" />
                  Invio in corso...
                </>
              ) : (
                'Invia Istruzioni'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
